import { localized, msg } from "@lit/localize";
import { BaseExtraButton, type Params } from "@whilecat/core/editors/buttons/base-extra-button.js";
import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

const noop = () => {};

@localized()
@customElement("show-answer-button")
export class ShowAnswerButton extends BaseExtraButton {
    @property({ attribute: false }) showAnswerCallBack: () => void = noop;

    static html({ onclick = noop, visible, disabled, toggled }: Params & { onclick: () => void }) {
        return html`<show-answer-button
            @click=${onclick}
            ?visible=${visible}
            ?disabled=${disabled}
            ?toggled=${toggled}>
        </show-answer-button>`;
    }

    constructor() {
        super("magic", "stars", msg("Show answer"));
    }

    onClicked() {
        super.playToggleAnimation();
        this.showAnswerCallBack();
    }

    static styles = [
        super.styles,
        css`
          .extra-button:not([disabled]) {
            position: relative;
            z-index: 1;
            animation: appearAnimation ease-in 1s;
          }

          sl-icon-button.extra-button:not([disabled])::part(base) {
            color: var(--sl-color-cyan-600);
          }

          sl-icon-button.extra-button-toggled::part(base) {
            color: var(--sl-color-green-800);
          }

          .extra-button-overlay:not([disabled]) {
            animation: overlayAppearAnimation ease-in 2s;
            position: absolute;
            top: 50%;
            left: 10%;
            width: 25%;
            pointer-events: none;
            z-index: -1;
            box-shadow: 0 0 10px 5px var(--sl-color-cyan-300);
            opacity: 0.7;
          }

          @keyframes overlayAppearAnimation {
            0% {
              border-radius: 100px;
              box-shadow: 0 0 0 0 var(--sl-color-cyan-500)
            }
            50% {
              border-radius: 100px;
              box-shadow: 0 0 10px 7px var(--sl-color-cyan-500)
            }
            100% {
              opacity: 0.7;
              box-shadow: 0 0 10px 5px var(--sl-color-cyan-300);
            }
          }

          @keyframes appearAnimation {
            0% {
              opacity: 0.3;
            }
            100% {
              opacity: 1;
            }
          }
        `,
    ];
}
